import { getPatternStyles, patternFns } from './runtime.mjs';
import { memo } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const hstackConfig = {
  transform(props) {
    const { justify, gap, ...rest } = props;
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: justify,
      gap,
      flexDirection: "row",
      ...rest
    };
  },
  defaultValues: { gap: "0" }
}

export function hstackRaw(styles) {
  const s = getPatternStyles(hstackConfig, styles || {})
  return hstackConfig.transform(s, patternFns)
}

export const hstack = /* @__PURE__ */ Object.assign(/* @__PURE__ */ memo(function hstack(styles = {}) {
  return css(hstackRaw(styles))
}), { raw: hstackRaw, propKeys: ["gap","justify"] })